import React from 'react'
import ModeratorTopBar from 'components/ModeratorTopBar'

const ModeratorTemplate = ({ children }) => {
  return (
    <>
      <ModeratorTopBar />
      <div style={{ height: '100%' }}>{children}</div>
    </>
  )
}

export default ModeratorTemplate
